<template>
  <div :class="{ webwallet: account }">
    <web-nav />
    <login v-if="!account" />
    <template v-else-if="account">
      <side-bar />
      <section class="main-info">
        <div class="main-container">
          <div class="tabs">
            <router-link class="tab" to="../assets" append>
              {{ $t("assets") }}
            </router-link>
            <router-link class="tab" to="../collectibles" append>
              {{ $t("collectibles") }}
            </router-link>
          </div>
          <router-view class="transfer-container"></router-view>
        </div>
      </section>
    </template>
  </div>
</template>
<script>
import webNav from "base/nav";
import login from "base/login";
import sideBar from "base/sidebar";
export default {
  components: {
    sideBar,
    login,
    webNav,
  },
};
</script>
